import { __decorate, __extends } from "tslib";
import { Options } from 'vue-class-component';
import AvalonGTView from '@/utils/libs/BaseView';
import NavPanel from '@/components/common/NavPanel.vue';
import { PageService } from '@/views/copy/recharge/import';
import vipImgs from './imgs';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.vipImgs = vipImgs;
        _this.showPopup = false; // 2022/3/1 17:52 安卓支付弹窗
        _this.rechargeForm = {
            radio: '1',
        }; // 2022/3/2 10:10 支付渠道选择
        _this.equipment = '';
        _this.vipData = {};
        _this.userInfo = {}; // 2022/3/2 16:20 用户详情  status 0 未开通 1 过期 2 vip
        _this.loading = false;
        _this.selectVip = {}; // 2022/3/2 17:01 选中的vip
        _this.activeIcon = '';
        _this.inactiveIcon = '';
        _this.isDiscount = false; // 2022/3/23 10:41 是否显示折扣
        _this.payment = {
            wxpay: 1,
            alipay: 2,
            honorpay: 7,
        }; //  2024-06-17 10:28:40：支付方式
        // 是否华为畅享 70（机型代号 FGD-AL00）
        // 这台机底部手势条会盖住 footer，env(safe-area-inset-bottom) 又返回 0，CSS 单独兜底；其它机型不动
        _this.isFgdAl00 = /FGD-AL00/i.test(navigator.userAgent || '');
        _this.recommendVip = {};
        // 顶部 nav 背景色：默认透明，滚动超过阈值后切到页面底色
        _this.navBg = 'transparent';
        _this.scrollEl = null;
        _this.NAV_BG_THRESHOLD = 60;
        // 滚动联动：> 阈值 → 深色底；回到顶部 → 透明
        _this.onContentScroll = function () {
            if (!_this.scrollEl)
                return;
            var top = _this.scrollEl.scrollTop || 0;
            _this.navBg = top > _this.NAV_BG_THRESHOLD ? '#141617' : 'transparent';
        };
        return _this;
    }
    Object.defineProperty(View.prototype, "vipSlogan", {
        /** 顶部会员卡描述文案：接口未下发时用设计稿默认文案 */
        get: function () {
            var _a, _b;
            var count = ((_b = (_a = this.selectVip) === null || _a === void 0 ? void 0 : _a.privilege) === null || _b === void 0 ? void 0 : _b.length) || 6;
            return "\u5C0A\u4EAB" + count + "\u5927\u6743\u76CA\uFF0C\u5C0A\u4EAB\u7279\u6743\u670D\u52A1\u4F60\u7684\u6BCF\u4E00\u4E2A\u9700\u6C42\u3002\u6210\u4E3AVIP\uFF0C\u4EAB\u53D7\u9876\u7EA7\u7684\u8D44\u6E90\u3002";
        },
        enumerable: false,
        configurable: true
    });
    /** 权益图标按顺序取 CDN：icon-1.png / icon-2.png … */
    View.prototype.privilegeIcon = function (index) {
        return this.vipImgs.privilegeIcon(Number(index) + 1);
    };
    View.prototype.mounted = function () {
        var _this = this;
        this.loading = true;
        this.activeIcon = this.awlGlobalConfig.getH5ImgUrl('recharge/radio-selected@3x.png');
        this.inactiveIcon = this.awlGlobalConfig.getH5ImgUrl('recharge/select.png');
        // 2022/3/2 15:44 获取设备信息
        this.equipment = this.awlGlobalConfig.isEquipmentEnvironment();
        this.getVip();
        window['doReloadData'] = function (result) {
            _this.doReloadData(result);
        };
        // NavPanel 内部 .nav-content 是真正的滚动容器，监听它的 scroll
        this.$nextTick(function () {
            var root = _this.$refs.navPanelRef && _this.$refs.navPanelRef.$el;
            var el = root && root.querySelector ? root.querySelector('.nav-content') : null;
            if (!el)
                return;
            _this.scrollEl = el;
            el.addEventListener('scroll', _this.onContentScroll, { passive: true });
        });
    };
    View.prototype.unmounted = function () {
        if (this.scrollEl) {
            this.scrollEl.removeEventListener('scroll', this.onContentScroll);
            this.scrollEl = null;
        }
    };
    // 2022/3/2 15:46 获取用户信息及会员状态
    View.prototype.getVip = function () {
        var _this = this;
        PageService.getVipData({
            os: this.equipment == 'Android' ? '1' : '2',
            osv: this.awlGlobalState.urlInitParams.version,
            channel: this.equipment == 'Android' ? '' : 'apple',
        }).then(function (data) {
            _this.loading = false;
            _this.vipData = data;
            _this.rechargeForm.radio = data.platforms.length != 0 ? data.platforms[0].type : '';
            _this.userInfo = data.info;
            var selectVipItem = data.price.filter(function (item) {
                return item.isSelected;
            })[0];
            _this.selectVip = selectVipItem;
            console.log('🥳 ~ this.selectVip:', _this.selectVip);
            // 推荐套餐
            _this.recommendVip = JSON.parse(JSON.stringify(selectVipItem || {}));
            if (!_this.selectVip) {
                _this.selectVip = _this.vipData.price[0];
            }
            _this.isDiscount = _this.equipment == 'IOS' && data.appConfig.imode == 2;
        });
    };
    // 2022/3/3 15:21 选择会员
    View.prototype.selectVipHandle = function (item) {
        this.selectVip = item;
    };
    /** 套餐价格只展示整数部分（不四舍五入） */
    View.prototype.toIntPrice = function (price) {
        var num = Number(price);
        if (isNaN(num))
            return price !== null && price !== void 0 ? price : '';
        return String(Math.floor(num));
    };
    /**
     * 立省金额 = price - discountPrice，固定一位小数（截断，不四舍五入）
     * 先换算成「分」整数再相减，避免浮点误差
     */
    View.prototype.getVipSaveAmount = function (item) {
        var _a, _b;
        var toCents = function (v) { return Math.floor(Number(v) * 100 + 1e-8); };
        var saveCents = Math.max(0, toCents((_a = item === null || item === void 0 ? void 0 : item.price) !== null && _a !== void 0 ? _a : 0) - toCents((_b = item === null || item === void 0 ? void 0 : item.discountPrice) !== null && _b !== void 0 ? _b : 0));
        var truncated = Math.floor(saveCents / 10) / 10;
        return truncated.toFixed(1);
    };
    // 2022/3/2 15:38 开通 / 续费：弹出支付渠道选择
    View.prototype.getRenewal = function () {
        this.rechargeForm.radio = this.vipData.platforms.length != 0 ? this.vipData.platforms[0].type : '';
        this.showPopup = true;
    };
    // 2022/3/2 16:44 调用原生支付方法
    View.prototype.paySubmit = function () {
        var params = {
            goodsId: this.selectVip.id,
            payMethod: this.payment[this.rechargeForm.radio],
            action: 5,
            no: this.selectVip.no,
            renewVip: Boolean(this.userInfo.status == 2),
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    // 2022/3/2 17:16 原生调用H5方法
    View.prototype.doReloadData = function (result) {
        this.showPopup = false;
        this.getVip();
    };
    // 2023/11/27 16:33  跳转会员协议页面
    View.prototype.toMemberShip = function () {
        var param = {
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            mark: this.awlGlobalState.urlInitParams.mark,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/membership',
            query: param,
        });
    };
    View = __decorate([
        Options({
            components: { NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
